import State from '../state'

export default class Utilities {

	constructor() {

		this.buildDetails()
		this.state = new State()
		this.prettyLog()
	}

	/** 
	 *	Pretty console logs
	 *	This function uses the application state to detect the environment and does not display in production	
	 */
	prettyLog() {

		var style = 'color: #000; font-weight: bold; text-decoration: underline; text-decoration-style: dotted;'

		window.log = ( ...options ) => {

			window.log.history = log.history || []
			window.log.history.push( options )

			if ( this.state.env !== 'production' ) {				
				options.unshift( '%c' + this.state.name, style )

				if ( window.console ) {
					console.log.apply( console, options )
				}
			}
		}

		window.error = ( ...options ) => {

			window.error.history = error.history || []
			window.error.history.push( options )

			if ( this.state.env !== 'production' ) {
				options.unshift( '%c' + this.state.name, style )

				if ( window.console )
					console.error.apply( console, options )
			}
		}

		window.info = ( ...options ) => {

			window.error.history = error.history || []
			window.error.history.push( options )

			if ( this.state.env !== 'production' ) {

				options.unshift( '%c' + this.state.name, style )

				if ( window.console )
					console.info.apply( console, options )
			}
		}
	}

	/**
	 *	Keep build details in global space for easy inspection
	 */
	buildDetails() {

		const $details = $('#build-details')

		window.project = $.extend( { 'jQuery version': $.fn.jquery, 'Environment': state.env, 'Project': state.name }, {
			site: $details.attr('data-site'),
			name: $details.attr('data-name'),
			built: new Date( $details.attr('data-built') ),
			publisher: $details.attr('data-publisher'),
		})

		$details.remove()
	}
}